<div class="pickup-page">
  <p-confirmDialog></p-confirmDialog>
  <app-pickup-chat></app-pickup-chat>
  <p-card styleClass="pickup-card">
    @if (loading || !settingsService.settings()) {
    <div class="pickup-loading">
      <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
    </div>
    }

    <section class="pickup-overview">
      <div class="pickup-page-header">
        <div>
          <span class="pickup-location">{{ location()?.city ?? 'Ausgabe' }}</span>
          <h1>{{ today | date : 'EEEE, dd.MM.yyyy' }}</h1>
        </div>
        <p-button [text]="true" size="small" label="Logout" icon="pi pi-sign-out"
          (click)="authService.logout()"></p-button>
      </div>

      <div class="pickup-metrics">
        <div class="pickup-metric-card">
          <span class="pickup-metric-label">Kisten</span>
          <strong>{{ getRemainingBoxCount() }}</strong>
          <span class="pickup-metric-note">verbleibend</span>
        </div>
        <div class="pickup-metric-card">
          <span class="pickup-metric-label">Nutzer</span>
          <strong>{{ getRemainingCustomersCount() }}</strong>
          <span class="pickup-metric-note">{{ getRemainingAdultsCount() }} E | {{ getRemainingChildrenCount() }} K ({{
            getRemainingAdultsCount() + getRemainingChildrenCount() }} Gesamt)</span>
        </div>
        <div class="pickup-metric-card income">
          <span class="pickup-metric-label">Einnahmen</span>
          <strong>{{ getCurrentIncome() }} €</strong>
          <span class="pickup-metric-note">bisher</span>
        </div>
      </div>

      <div class="pickup-progress">
        <div>
          <span>Fortschritt</span>
          <strong>{{ completionPercentage() }}%</strong>
        </div>
        <p-progressBar [value]="completionPercentage()" [showValue]="false" />
      </div>
    </section>

    @if (customersAtCooling().length > 0) {
    <section class="pickup-section">
      <div class="pickup-section-header">
        <h2>Kühlung</h2>
        <span>{{ customersAtCooling().length }} offen</span>
      </div>

      <p-listbox scrollHeight="auto" [options]="customersAtCooling()" [style]="{ width: '100%' }"
        styleClass="pickup-listbox" [readonly]="true">
        <ng-template let-customer pTemplate="item">
          <div class="pickup-customer-row cooling clickable"
            (click)="authService.user()?.role?.id !== RoleEnum.READ ? handleCustomer(customer) : undefined">
            <div class="pickup-row-header">
              <div class="pickup-row-title">
                <h3>{{ customer.first_name | slice : 0 : 1 }}. {{ customer.last_name }}</h3>
                <span>{{ customer | code }}</span>
              </div>
              @if (authService.user()?.role?.id !== RoleEnum.READ) {
              <i class="pi pi-chevron-right"></i>
              }
            </div>

            <div class="pickup-tags">
              @if (location()?.showCustomerAddress) {
              <p-tag value="{{customer.street}} {{customer.house_number}}, {{customer.zip}} {{customer.city}}"></p-tag>
              }
              <p-tag value="{{settingsService.calculateBoxCount(customer)}} Kiste(n)"></p-tag>
              @if ((customer.code ?? customer.code_rotation_1 ?? customer.code_rotation_2).isFreeCode) {
              <p-tag value="GRATIS"></p-tag>
              } @else {
              <p-tag value="{{getCustomerDueAmount(customer)}} €"></p-tag>
              }
              <p-tag value="{{customer.family_members | household | async}}"></p-tag>
              @if (this.customerHasChildren(customer.family_members)) {
              <p-tag>Alter: {{ customer.family_members | agesList }}</p-tag>
              }
              @if (customer.shop_remark) {
              <p-tag [value]="customer.shop_remark"></p-tag>
              }
              @if (customer.collection_remark) {
              <p-tag [value]="customer.collection_remark"></p-tag>
              }
              @if (!customer.pickups) {
              <p-tag value="NEU"></p-tag>
              }
            </div>

            @if (authService.user()?.role?.id !== RoleEnum.READ) {
            <div class="pickup-row-actions">
              <p-button [outlined]="true" size="small" icon="pi pi-undo" label="Zurück"
                (click)="deletePickup(customer.id, $event)">
              </p-button>
              <p-button [outlined]="true" size="small" icon="pi pi-check" label="Kühlung erhalten"
                (click)="$event.stopPropagation(); receivedCooling(customer.id)">
              </p-button>
            </div>
            }
          </div>
        </ng-template>
      </p-listbox>
    </section>
    }

    @if (customersToday().length > 0) {
    <section class="pickup-section">
      <div class="pickup-section-header">
        <h2>Offene Ausgabe</h2>
        <span>{{ getRemainingCustomersCount() }} Nutzer</span>
      </div>

      <p-iconfield class="pickup-search">
        <p-inputicon class="pi pi-search"></p-inputicon>
        <input id="search" type="text" placeholder="Name oder Nummer suchen"
          (keyup)="filterCustomers($any($event.target).value)" pInputText />
      </p-iconfield>

      @for (group of customersToday(); track group.time) {
      @if (group.time) {
      <h3 class="pickup-time-heading">{{ group.time | slice:0:5 }} Uhr</h3>
      }

      <p-listbox scrollHeight="auto" [options]="group.customers" [style]="{ width: '100%' }" styleClass="pickup-listbox"
        [readonly]="true">
        <ng-template let-customer pTemplate="item">
          <div class="pickup-customer-row clickable"
            (click)="authService.user()?.role?.id !== RoleEnum.READ ? handleCustomer(customer) : undefined">
            <div class="pickup-row-header">
              <div class="pickup-row-title">
                <h3>{{ customer.first_name | slice : 0 : 1 }}. {{ customer.last_name }}</h3>
                <span>{{ customer | code }}</span>
              </div>
              @if (authService.user()?.role?.id !== RoleEnum.READ) {
              <i class="pi pi-chevron-right"></i>
              }
            </div>

            <div class="pickup-tags">
              @if (location()?.showCustomerAddress) {
              <p-tag value="{{customer.street}} {{customer.house_number}}, {{customer.zip}} {{customer.city}}"></p-tag>
              }
              <p-tag value="{{settingsService.calculateBoxCount(customer)}} Kiste(n)"></p-tag>
              @if ((customer.code ?? customer.code_rotation_1 ?? customer.code_rotation_2).isFreeCode) {
              <p-tag value="GRATIS"></p-tag>
              } @else {
              <p-tag value="{{getCustomerDueAmount(customer)}} €"></p-tag>
              }
              <p-tag value="{{customer.family_members | household | async}}"></p-tag>
              @if (this.customerHasChildren(customer.family_members)) {
              <p-tag>Alter: {{ customer.family_members | agesList }}</p-tag>
              }
              @if (customer.shop_remark) {
              <p-tag [value]="customer.shop_remark"></p-tag>
              }
              @if (customer.collection_remark) {
              <p-tag [value]="customer.collection_remark"></p-tag>
              }
              @if (!customer.pickups) {
              <p-tag value="NEU"></p-tag>
              }
            </div>
          </div>
        </ng-template>
      </p-listbox>
      }
    </section>
    } @else {
    <div class="pickup-empty-state">
      <i class="pi pi-check-circle"></i>
      <span>Keine verbleibenden Nutzer</span>
    </div>
    }
    <p-panel header="Abgeschlossen" styleClass="pickup-completed-panel" [toggleable]="true" [collapsed]="true">
      @if (completedCustomers().length > 0) {
      <p-listbox scrollHeight="auto" [options]="completedCustomers()" [style]="{ width: '100%' }"
        styleClass="pickup-listbox" [readonly]="true">
        <ng-template let-customer pTemplate="item">
          <div class="pickup-customer-row completed clickable"
            (click)="authService.user()?.role?.id !== RoleEnum.READ ? handleCustomer(customer) : undefined">
            <div class="pickup-row-header">
              <div class="pickup-row-title">
                <h3>{{ customer.first_name | slice : 0 : 1 }}. {{ customer.last_name }}</h3>
                <span>{{ customer | code }}</span>
              </div>
            </div>

            <div class="pickup-completed-meta">
              <span>
                {{ customer.code?.time ?? customer.code_rotation_1?.time ?? customer.code_rotation_2?.time | slice : 0:5
                }}
                Uhr
              </span>
              @if (this.getTodayPickUp(customer)?.comment) {
              <span>{{ this.getTodayPickUp(customer)?.comment?.comment }}</span>
              }
            </div>
            <div class="pickup-tags">
              @if (this.getTodayAbsence(customer)) {
              <p-tag severity="danger"
                value="ABWESEND ({{this.getAbsenceStatusLabel(this.getTodayAbsence(customer)!.absence_status)}})"></p-tag>
              }
              @if (this.getTodayPickUp(customer)) {
              <p-tag severity="success" value="ABGEHOLT"></p-tag>
              }
              @if (this.getTodayPickUp(customer)?.received_cooling) {
              <p-tag value="KÜHLUNG ERHALTEN"></p-tag>
              }
              @if (this.getTodayPickUp(customer)?.unpaid_balance) {
              <p-tag value="{{this.getTodayPickUp(customer)?.unpaid_balance}} € Restschuld"></p-tag>
              }
            </div>
          </div>
        </ng-template>
      </p-listbox>
      } @else {
      <span class="pickup-muted">Keine fertigen Nutzer</span>
      }
    </p-panel>
  </p-card>
</div>

<p-drawer [visible]="selectedCustomer() !== undefined"
  (visibleChange)="selectedCustomer.set($event ? selectedCustomer() : undefined)" position="bottom"
  styleClass="pickup-customer-drawer" [showCloseIcon]="false"
  [style]="{ height: 'min(90dvh, 760px)', 'max-height': '90dvh' }">
  <ng-template #headless>
    @if (selectedCustomer()) {
    <div class="pickup-customer-sheet">
      <header class="pickup-customer-header">
        <div class="pickup-customer-title">
          <span class="pickup-customer-code">{{ selectedCustomer()! | code }}</span>
          <h2>{{ selectedCustomer()!.first_name }} {{ selectedCustomer()!.last_name }}</h2>
        </div>
        <button type="button" class="pickup-customer-close" aria-label="Schließen"
          (click)="selectedCustomer.set(undefined)">
          <i class="pi pi-times"></i>
        </button>
      </header>

      <div class="pickup-customer-content">
        @if (this.authService.user()?.role?.id === RoleEnum.Admin || this.authService.user()?.role?.id ===
        RoleEnum.Member) {
        <a class="dashboard-link" routerLink="/customers/edit/{{selectedCustomer()?.id}}">
          Im Dashboard öffnen
          <i class="pi pi-external-link"></i>
        </a>
        }

        @if (selectedCustomer()!.shop_remark || selectedCustomer()!.collection_remark) {
        <div class="pickup-remarks">
          @if (selectedCustomer()!.shop_remark) {
          <div class="pickup-remark">
            <i class="pi pi-info-circle"></i>
            <span>
              <strong>Bemerkung Ladendienst:</strong>
              {{ selectedCustomer()!.shop_remark }}
              (bis {{ selectedCustomer()!.shop_remark_valid_until | date : 'dd.MM.yyyy' }})
            </span>
          </div>
          }
          @if (selectedCustomer()!.collection_remark) {
          <div class="pickup-remark">
            <i class="pi pi-exclamation-circle"></i>
            <span><strong>Besonderheit Abholung:</strong> {{ selectedCustomer()!.collection_remark }}</span>
          </div>
          }
        </div>
        }

        @if (selectedTodayPickUp()) {
        <div class="pickup-remark">
          <i class="pi pi-check-circle"></i>
          <span>
            <strong>Abholung erfasst:</strong>
            @if (selectedTodayPickUp()?.received_cooling) {
            Kühlware wurde bereits ausgegeben.
            } @else {
            Kühlware ist noch offen.
            }
          </span>
        </div>
        }

        @if (getTodayAbsence(selectedCustomer()!)) {
        <div class="pickup-remark">
          <i class="pi pi-exclamation-circle"></i>
          <span>
            <strong>Fehlzeit erfasst:</strong>
            {{ getAbsenceStatusLabel(getTodayAbsence(selectedCustomer()!)!.absence_status) }}
          </span>
        </div>
        }

        @if (settingsService.settings()) {
        <div class="pickup-stats">
          <div class="pickup-stat-card">
            <span class="pickup-stat-label">Erwachsene</span>
            <span class="pickup-stat-note">&gt; {{ settingsService.settings()!.adultAge }} Jahre</span>
            <span class="pickup-stat-value">{{ selectedAdultCount() }}</span>
          </div>
          <div class="pickup-stat-card">
            <span class="pickup-stat-label">Kinder</span>
            <span class="pickup-stat-note">&lt; {{ settingsService.settings()!.adultAge }} Jahre</span>
            <span class="pickup-stat-value">{{ childrenCount() }}</span>
          </div>
          <div class="pickup-stat-card">
            <span class="pickup-stat-label">Kisten</span>
            <span class="pickup-stat-value">{{ boxCount() }}</span>
          </div>
          <div class="pickup-stat-card amount">
            <span class="pickup-stat-label">Betrag</span>
            @if (!selectedTodayPickUp() && selectedCustomer()?.pickups?.[0]?.unpaid_balance) {
            <span class="pickup-stat-note">
              inkl. Nachzahlung vom {{ selectedCustomer()?.pickups?.[0]?.date | date : 'dd.MM.yyyy' }}
            </span>
            }
            <span class="pickup-stat-value">
              {{ selectedTotalDue() }} €
            </span>
            @if (!selectedTodayPickUp() && selectedCustomer()!.pickups?.[0]?.unpaid_balance) {
            <span class="pickup-stat-note">
              {{ calculatedPrice() }} € + {{ selectedCustomer()!.pickups![0].unpaid_balance }} €
            </span>
            }
          </div>
        </div>
        }

        <div class="pickup-form-field">
          <label for="new_unpaid_balance">Restschuld</label>
          <input pInputText type="number" id="new_unpaid_balance" aria-describedby="new_unpaid_balance_help"
            [(ngModel)]="newUnpaidBalance" />
          <small id="new_unpaid_balance_help">Nur eintragen, wenn nicht vollständig bezahlt wurde.</small>
        </div>

        <div class="pickup-form-field">
          <label for="comment">Kommentar</label>
          <textarea pTextarea id="comment" rows="3" [(ngModel)]="comment"></textarea>
        </div>
      </div>

      <footer class="pickup-customer-actions">
        @if (getTodayAbsence(selectedCustomer()!)) {
        <p-button label="Fehlzeit löschen" severity="danger" icon="pi pi-trash"
          class="w-100 justify-content-center" styleClass="w-100 pickup-action-button"
          (click)="deleteAbsence(selectedCustomer()?.id)">
        </p-button>
        } @else if (selectedTodayPickUp()) {
        <p-button label="Abholung löschen" severity="danger" icon="pi pi-trash"
          class="w-100 justify-content-center" styleClass="w-100 pickup-action-button"
          (click)="deletePickup(selectedCustomer()?.id)">
        </p-button>
        <p-button label="Speichern" severity="success" icon="pi pi-save"
          class="w-100 justify-content-center" styleClass="w-100 pickup-action-button" (click)="pickUpBox()">
        </p-button>
        @if (selectedTodayPickUp()?.received_cooling) {
        <p-button label="Kühlung zurücknehmen" icon="pi pi-undo"
          class="w-100 justify-content-center" styleClass="w-100 pickup-action-button"
          (click)="setReceivedCooling(selectedCustomer()?.id, false)">
        </p-button>
        } @else {
        <p-button label="Kühlung erhalten" icon="pi pi-check"
          class="w-100 justify-content-center" styleClass="w-100 pickup-action-button"
          (click)="setReceivedCooling(selectedCustomer()?.id, true)">
        </p-button>
        }
        } @else {
        <p-button label="Nicht erschienen" severity="danger" class="w-100 justify-content-center"
          styleClass="w-100 pickup-action-button" (click)="markAbsent()"
          [disabled]="getTodayAbsence(selectedCustomer()!)">
        </p-button>
        <p-button severity="success" class="w-100 justify-content-center" styleClass="w-100 pickup-action-button"
          (click)="pickUpBox()" [disabled]="getTodayPickUp(selectedCustomer()!)"
          label="{{ getPaidAmount() }} € bezahlt">
        </p-button>
        }
      </footer>
    </div>
    }
  </ng-template>
</p-drawer>
